<template>
  <b-container   fluid>
    <b-row   :style="gradientGobinet + 'min-height:auto;'">
          
      <b-col cols="12"  class="mt-5">
        <b-row align-h="center" class="row-login mt-5">
          <b-col xl="3" lg="4" md="6" sm="10" cols="12" class="border-login">
            <b-row align-h="center" class="text-center">
              <b-col cols="12" md="11" ><br>
                  <a :href="linkLanding" target="_blank"><b-img fluid :src="icon" width="260px"></b-img></a>          
              </b-col>
            </b-row>
            <b-row align-h="center" class="text-center">
              <b-col cols="12" md="11" class="mb-4"><br>
                  <h5 style="color:white"><b-icon icon="cash"/> Recaudación</h5>                  
              </b-col>
            </b-row>
            <b-row align-h="center" class="text-center">
              <b-alert variant="secondary" :show="msgErrorLogin != ''" dismissible>
                {{msgErrorLogin}}
              </b-alert>
            </b-row>
            <b-row align-h="center">
              <b-col cols="12" md="11">
                  <b-form-group label="Usuario:" class="input-label">
                    <b-form-input class="input" :state="!$v.inTxtUser.$invalid" type="text" v-model.trim="$v.inTxtUser.$model" @change="cleanResults"></b-form-input>
                    <div class="error" v-if="!$v.inTxtUser.minLength">El Nombre de usuario es demasiado corto</div>
                    <div class="error" v-if="!$v.inTxtUser.maxLength">El Nombre de usuario es demasiado largo</div>
                    <div class="error" v-if="!$v.inTxtUser.required">Este campo es obligatorio</div>
                  </b-form-group>
              </b-col>
            </b-row>
            <b-row align-h="center">
              <b-col cols="12" md="11">
                  <b-form-group label="Contraseña:" class="input-label">
                    <b-form-input class="input" :state="!$v.inPassUser.$invalid" type="password" v-model.trim="$v.inPassUser.$model" @change="cleanResults"></b-form-input>
                    <div class="error" v-if="!$v.inPassUser.minLength">La Contraseña es demasiado corta</div>
                    <div class="error" v-if="!$v.inPassUser.maxLength">La Contraseña es demasiado larga</div>
                    <div class="error" v-if="!$v.inPassUser.required">Este campo es obligatorio</div>
                  </b-form-group>
              </b-col>
            </b-row>
            <b-row align-h="center" v-if="false">
              <b-col cols="12" md="11" >
                <vue-recaptcha theme="dark" ref="captchaLogin" sitekey="6LdD09sUAAAAANCvTN2xMZqvfMOvzkdkOB1Zcpok" @verify="captchaLoginFilled" @expired="captchaLoginExpired" :loadRecaptchaScript="true" /><br>
                <div class="error" v-if="isShowMsgCaptcha">Por favor complete el captcha.</div>
              </b-col>
            </b-row>
            <b-row align-h="center" class="text-center">
              <b-col cols="12" md="11">
                  <b-button block size="lg" variant="success" @click="login">
                      <b-spinner v-if="isLoging"></b-spinner>
                      <strong v-if="isLoging"> INICIANDO . . .</strong>
                      <strong v-if="!isLoging"> INICIAR SESIÓN</strong>
                  </b-button><br/>
                  <b-link>
                    <span class="rec-contrasena-text" @click="showModal">Recuperar Contraseña</span>
                  </b-link>
              </b-col>
            </b-row>
            <br>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row style="margin-top:-6%;">
      <b-col >
            <!-- efecto del encabezado -->
            <CurveShape  id="ventajas">
                <template v-slot:bgcolor>
                    <path style="fill: #f6f5f9;
                        stroke-miterlimit:10;" 
                        d="M 3360.5 97.739 c -242 0 -480 -48.375 -480 -48.375 S 2647.5 0.5 2400.5 0.5 s -480 48.375 -480 48.375 s -238 48.864 -480 48.864 s -480 -48.375 -480 -48.375 S 727.5 0.5 480.5 0.5 S 0.5 48.875 0.5 48.875 V 173 h 1920 h 1920 V 48.875 C 3840.5 48.875 3602.5 97.739 3360.5 97.739 z"/>
                </template>
            </CurveShape>    
      </b-col>
    </b-row>

    <b-row align-h="center" align="center" class="mt-5" v-if="false">
          <b-col cols="12" class="mt-4">
            <h4 style="color: #312bb5;">Acceso Otros Módulos</h4>
          </b-col>
          <b-col cols="11" sm="11" md="10" lg="8" xl="8">
            <b-row align-h="center" align="center">

              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="people-fill"/>
                <h6>Nómina</h6>
              </b-col>
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="file-spreadsheet-fill"/>
                <h6>Contabilidad</h6>
              </b-col>
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="newspaper"/>
                <h6>Bancos</h6>
              </b-col>
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="map-fill"/>
                <h6>Catastro</h6>
              </b-col>
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="house-door-fill"/>
                <h6>Bienes Patrimoniales</h6>
              </b-col>
            </b-row>
            <b-row align-h="center" align="center">
              <b-col cols="12"><b-form-checkbox v-model="isShowModulos"><h5 style="color: #312bb5;">Mostrar más</h5></b-form-checkbox></b-col>
            </b-row>
            <b-row align-h="center" align="center" v-if="isShowModulos">
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="bar-chart-fill"/>
                <h6>PbRMs</h6>
              </b-col> 
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="laptop"/>
                <h6>Trámites En Línea</h6>
              </b-col>              
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="pencil-square"/>
                <h6>Firma Electrónica</h6>
              </b-col>
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="grid-fill"/>
                <h6>Mejora Regulatoria</h6>
              </b-col>
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="code-square"/>
                <h6>Página WEB</h6>
              </b-col>
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="search"/>
                <h6>Transparencia</h6>
              </b-col>              
              <b-col cols="5" md="3" lg="2" class="acceso-tab">
                <b-icon icon="building"/>
                <h6>Obra Pública</h6>
              </b-col>              
              
            </b-row>
          </b-col>
        </b-row>
    
    <!-- modals -->
    <b-modal v-model="isShowModal" title="Recuperar Contraseña">
        <p>Para recuperar su contraseña, pongase en contacto con el administrador del sistema</p>
    </b-modal>
    
 
  </b-container>
</template>

<script>
  import { minLength, maxLength, required } from 'vuelidate/lib/validators';
  import VueRouter from 'vue-router';
  import Vue from 'vue';
  import axios from 'axios';
  import { server, handledError, getPostConfig } from '@/axios-tools';
  import { mapState } from 'vuex';
  import { md5Malformed } from '@/auth-tools';
  import VueRecaptcha from 'vue-recaptcha';
  import CurveShape from './CurveShape.vue'
  
  Vue.use(VueRouter)

  export default {
    computed:{
      ...mapState({
        msgErrorLogin: state => state.login.msgErrorLogin
      }),
      rowToImg() {
        var img = this.$route.params.municipio=='taxco'?"url('../imgs/img-login-taxco.jpg')":"url('../imgs/img-login.jpg')";
        return {
          //'background-image':"url('../imgs/"+this.$route.params.municipio+".jpg')",
          
          'background-image':img,
          'background-size': '100% 100%',
          'min-height':(this.height)+'px',
          'max-height':(this.height)+'px'
        };
      },
      icon: function(){
        var mpio = this.$route.params.municipio;
        return mpio.includes('aguahuix')?'/media/sah.ico':mpio.includes('prueba')?'/media/logingob.ico':'/media/gobinetw.ico';
      },
      gradientGobinet: function(){
        const gobinet = "background: linear-gradient(308deg, #3b4ee8, #4c46e8, #6839e8,  #872be8, #9f20e9, #b117e7);  background-size: 180% 180%;  animation: gradient-animation 5s ease infinite;";
        const huixquilucan = "background: linear-gradient(308deg, #19225c, #19225c, #192075,  #192075, #0b4e91, #0b4e91);  background-size: 180% 180%;  animation: gradient-animation 5s ease infinite;";
        const mpio = this.$route.params.municipio;
        return   mpio.includes('huixqui') || mpio.includes('prueba')? huixquilucan : gobinet;

      },
      linkLanding:function(){
        var mpio = this.$route.params.municipio;
        return mpio.includes('aguahuix')?'http://sah.gob.mx':'https://www.gobinet.mx';
        
      }
    },
    components: {
      VueRecaptcha, CurveShape
    },
    data() {
      return {
        inTxtUser: "",
        inPassUser: "",
        isShowModal: false,
        isLoging: false,
        showPasswordIncorrect: true,
        data: null,
        captchaLogin:null,
        isShowMsgCaptcha:false,
        height:window.innerHeight,
        isShowModulos:false
      }
    },
    mounted(){
      if(window.matchMedia("(max-width: 768px)").matches){
        this.$store.commit("updateIsShowSideCobro", false);
        
      }
      window.scrollTo(0, 0);
    },
    methods: {
      captchaLoginFilled(token){
      this.captchaLogin = token;
      this.isShowMsgCaptcha = false;
      },
      captchaLoginExpired(){
        this.captchaLogin = null;
      },
      cleanResults(){
        this.$store.commit("updateMsgErrorLogin", "");
      },
      login(){
          this.$v.$touch();
          if(!this.$v.$invalid){
            // if(this.captchaLogin != null){
              this.isLoging=true;
              this.cleanResults();
              var pass = this.inPassUser.trim().length <20? md5Malformed(this.inPassUser.trim()) : this.inPassUser.trim();
              axios(
                getPostConfig(server.authenticate,
                  this.data={username: this.inTxtUser+'-'+this.$route.params.municipio, password:pass, captcha:this.captchaLogin},
                  null)
              ).then(res => {
                this.$store.commit("updateToken", res.data[0].token);
                this.$store.commit("updateTreeGrant", res.data[1] != null ? res.data[1].treeCategorias : null);
                this.$store.commit("updateCatalogCobro", res.data[1]);
                this.$store.commit("updateTipoCatalogo", res.data[1].tipoCatalogo);
                this.$store.commit("updateCatalogFormas", res.data[2]);
                this.$store.commit("updateCatalogReportes", res.data[3]);
                this.$store.commit("updateCatalogoPadrones", res.data[4]);
                this.$store.commit("updateCatalogoAdmin", res.data[5]);
                this.cleanResults();
                if(res.data[1] != null){
                  this.$router.push("/"+this.$route.params.municipio+'/cobro');
                  this.$store.commit("updateIsShowSideCobro", true);
                }else if(res.data[2]){
                  this.$router.push("/"+this.$route.params.municipio+'/formas');
                }else if(res.data[3]){
                  this.$router.push("/"+this.$route.params.municipio+'/reportes');
                }else if(res.data[4]){
                  this.$router.push("/"+this.$route.params.municipio+'/padrones');
                }
                this.isLoging=false;
                this.captchaLogin = null;
                this.$refs.captchaLogin.reset();
              }).catch(err => {
                this.isLoging=false;
                this.captchaLogin = null;
                //this.$refs.captchaLogin.reset();
                handledError(err, server.authenticate, this.$router, this.$store);
              });
            // }else{
            //   this.isShowMsgCaptcha = true;
            // }
          }
      },
      showModal(){
          this.isShowModal = true
      }
    },
    validations: {
        inTxtUser:{
            required,
            minLength: minLength(4),
            maxLength: maxLength(20)
        },
        inPassUser:{
            required,
            minLength: minLength(4),
            maxLength: maxLength(166)
        }
    }
  }
</script>
<style>
.rec-contrasena-text{
  color:#6AD907;
}
.input{
  background-color: rgba(38, 38, 38, 0.7);
  color:#FFFFFF;
}
.input-label{
  color:#FFFFFF;
}
div.error     {color: red;}
.border-login {
              background-color: rgba(38, 38, 38, 0.5);
}
.row-login{
  margin-top:3%;
  margin-bottom:12%;
}
.acceso-tab{
  border-radius: 15px;
  /* border: 1px purple solid; */
  margin: 10px;
  background-color: rgba(38, 38, 38, 0.5);
  color:#FFFFFF;
  padding: 10px;
  cursor: pointer;
}

</style>